// extracted by mini-css-extract-plugin
module.exports = {"selectChannel":"index-module_selectChannel_1zmCR"};